export default __webpack_public_path__ + "static/media/messages.b219f2b0.gif";